import React from "react";
import { SELECT_BANK } from "../../../store/selectors/banksSelector";
import { useAppDispatch, useAppSelector } from "../../../store/reduxHooks";
import { SELECT_BANK_CHRONOLOGY_MODAL } from "../../../store/selectors/modalSelector";
import { BankChronology } from "../../../store/slice/banksSlice/banksSlice";
import { Modal, Table } from "antd";
import { CLOSE_BANK_CHRONOLOGY_MODAL } from "../../../store/slice/modalSlice/modalSlice";
import { BankChronologyCloumns } from "../config";

import classes from './BankChronologyModal.module.css';

export const BankChronologyModal = () => {
  const bank = useAppSelector(SELECT_BANK);
  const modal = useAppSelector(SELECT_BANK_CHRONOLOGY_MODAL);
  const dispatch = useAppDispatch();

  const columns = BankChronologyCloumns;

  const dataSource = bank?.bank_data_chronologies?.map((item, index) => {
    return columns.reduce((acc, column) => {
      if (column.key === "type") {
        // Условие для поля type
        acc[column.key] = index === 0 ? "A" : "B";
      } else {
        // Заполняем остальные поля

        const key = column.dataIndex as keyof BankChronology;
        if (item) acc[column.key] = item[key];
      }
      return acc;
    }, {} as Record<string, any>);
  });
  return (
    <Modal
      footer={<></>}
      open={modal.isOpen}
      className={classes.bankChronologyModal}
      onCancel={() => {
        dispatch(CLOSE_BANK_CHRONOLOGY_MODAL());
      }}
    >
      <div className={classes.bankChronologyModalTitle}>
        Хронология
      </div>
      <div className={classes.bankChronologyModalBankName}>
        Камкомбанк
      </div>
      <div className={classes.bankChronologyModalTitleTableWrapper}>
        <Table
          columns={columns}
          dataSource={dataSource}
          scroll={{ x: "max-content" }}
          className={classes.bankChronologyModalTable}
        />
      </div>
    </Modal>
  );
};
